// @flow
import { useMemo } from 'react'
import sdkMessages from 'mz-sdk/messages.intl'
import normalizeErrors from 'mz-sdk/utils/normalizeErrors'
import rawUseDataLoader from './useDataLoader'

/**
 * Custom error normalization logic that make it easier for the app
 * to handle errors and have translatable unkown error message.
 * @param  {any} error
 * @return {string | Message}
 */
const customErrorNormalizer = (error) => {
  const normResult = normalizeErrors(error)
  return normResult.errors[0] || sdkMessages.UNKOWN_ERROR
}

/**
 * Wrapper around `useDataLoader` hook that normalize errors
 * @param  {Function} loader  data getter function
 * @param  {Function} input dependencies arra
 * @return {State}
 */
export const useDataLoader = (((loader, inputs) => {
  const [state, actions] = rawUseDataLoader(loader, inputs)
  const newState = useMemo(
    () => ({
      ...state,
      error: state.error ? customErrorNormalizer(state.error) : null,
      rawError: state.error || null,
    }),
    [state]
  )
  return [newState, actions]
}: any): typeof rawUseDataLoader)
